import { Icon } from "@chakra-ui/react";

export const SearchIcon = (props) => (
  <Icon width="6" height="6" fill="none" {...props}>
    <path
      fill="#4B4F54"
      d="M9.38 2.396a7.36 7.36 0 0 0-7.356 7.356 7.36 7.36 0 0 0 7.357 7.357 7.36 7.36 0 0 0 7.356-7.357 7.36 7.36 0 0 0-7.356-7.356ZM9.054 15.7a5.96 5.96 0 0 1-5.959-5.96c0-3.285 2.663-5.97 5.96-5.97a5.96 5.96 0 0 1 5.959 5.96c0 3.285-2.663 5.97-5.96 5.97Z"
    />
    <path
      fill="#D11243"
      d="m21.769 20.186-5.817-5.228c-.36.447-.764.862-1.201 1.233l4.3 4.78c.72.809 1.976.841 2.74.077a.588.588 0 0 0-.022-.862Z"
    />
  </Icon>
);
